import React from 'react';
import groupPhoto from '../assets/photos/Groupphoto.jpg';  // Add this import
import Club_President_photo from '../assets/photos/Club_President_Image.png';
import vicePresidentPhoto from '../assets/photos/Vice_President_photo.png';
import secretaryPhoto from '../assets/photos/General_Secretery_photo.png';
import Faculty_1_photo from '../assets/photos/Faculty_coordinator_1.png';
import Faculty_2_photo from '../assets/photos/Faculty_coordinator_2.png';


const LeadershipCard = ({ name, role, description, photo }) => (
  <div className="bg-white/10 backdrop-blur-lg border border-white/30 rounded-xl p-6 flex flex-col items-center">
    <img
      src={photo || "/api/placeholder/200/200"}
      alt={name}
      className="w-32 h-32 rounded-full object-cover mb-4 border-4 border-white/30"
    />
    <h3 className="text-xl font-bold text-white mb-2">{name}</h3>
    <p className="text-white/80 font-medium mb-2">{role}</p>
    <p className="text-white/60 text-center text-sm">{description}</p>
  </div>
);

const TeamLeadership = ({ title, leaders }) => (
  <div className="mb-8">
    <h3 className="text-xl font-bold text-white mb-4 border-b border-white/20 pb-2">
      {title}
    </h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {leaders.map((leader, index) => (
        <div
          key={index}
          className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4"
        >
          <h4 className="text-white font-bold">{leader.name}</h4>
          <p className="text-white/80 text-sm">{leader.role}</p>
        </div>
      ))}
    </div>
  </div>
);

const AboutPage = () => {
  const facultyCoordinators = [
    {
      name: "Dr.Swagat Kumar Samantaray",
      role: "Faculty Coordinator",
      description: "Guiding the club's vision and academic integration since inception",
      photo: Faculty_1_photo
    },
    {
      name: "Dr.Ashok patel",
      role: "Faculty Coordinator",
      description: "Mentoring students and overseeing club initiatives since inception",
      photo: Faculty_2_photo
    }
  ];

  const mainLeadership = [
    {
      name: "Priya Sah",
      role: "President",
      description: "Leading club initiatives and fostering innovation",
      photo: Club_President_photo
    },
    {
      name: "Shreya Saniya ",
      role: "Vice President",
      description: "Supporting club operations and member engagement",
      photo: vicePresidentPhoto
    },
    {
      name: "Lipakshi Gijwani",
      role: "General Secretary",
      description: "Managing administrative affairs and coordination",
      photo: secretaryPhoto
    }
  ];

  const teamLeadership = {
    "PR & Outreach Team": [
      { name: "Keerti Vijay Ananth", role: "Team Lead" },
      { name: "John Davis", role: "Co-Lead" }
    ],
    "Event Management Team": [
      { name: "Aviraditya Singh", role: "Team Lead" },
      { name: "Harshit Yadav", role: "Co-Lead" }
    ],
    "Content Team": [
      { name: "Gunjan Bhardwaj", role: "Team Lead" },
      { name: "Bidisha Biswas", role: "Co-Lead" }
    ],
    "Social Media Team": [
      { name: "Ryan Joseph", role: "Team Lead" },
      { name: "Eva Rodriguez", role: "Co-Lead" }
    ],
    "Design Team": [
      { name: "R. Nidharshana", role: "Team Lead" },
      { name: "Annie Paul", role: "Co-Lead" }
    ],
    "Marketing Team": [
      { name: "Anirudh Singh", role: "Team Lead" },
      { name: "Eva Rodriguez", role: "Co-Lead" }
    ],
    "Technical Team": [
      { name: "Aditya Narayan Jha", role: "Team Lead" },
      { name: "Harsh Markandey", role: "Co-Lead" }
    ]
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 relative">
      <h1 className="text-3xl md:text-5xl font-bold mb-8 text-white text-center pt-32">
        About HealthoTechClub
      </h1>

      <div className="relative w-full max-w-6xl mx-auto mb-16 px-4">
        <div className="aspect-[21/9] rounded-3xl overflow-hidden">
          <img
            src={groupPhoto}
            alt="HealthoTechClub Group"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>
        </div>
      </div>

      <div className="container mx-auto px-4 pb-16">
        <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-2xl overflow-hidden mb-16">
          <div className="p-6 md:p-12">
            <p className="text-base md:text-xl text-white/80 mb-6 md:mb-8 leading-relaxed">
              HealthoTechClub is a dynamic platform dedicated to fostering innovation,
              collaboration, and community across technology, design, and entrepreneurship.
              Our mission is to connect passionate individuals and provide a seamless,
              intuitive experience for learning, networking, and growth.
            </p>
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Faculty Coordinators
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {facultyCoordinators.map((coordinator, index) => (
              <LeadershipCard key={index} {...coordinator} />
            ))}
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Student Leadership
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {mainLeadership.map((leader, index) => (
              <LeadershipCard key={index} {...leader} />
            ))}
          </div>
        </div>

        <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl p-8 mb-16">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Our Teams
          </h2>
          {Object.entries(teamLeadership).map(([teamName, leaders]) => (
            <div key={teamName} className="mb-12">
              <TeamLeadership title={teamName} leaders={leaders} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
